import React, { useState, useEffect, useCallback, useMemo } from "react";
import { toast } from "react-toastify";
import DeleteModal from "../../components/common/deleteModal";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import Widgets from "../dashboard/widgets";
import { useFormik } from "formik";
import * as Yup from "yup";
import { InputPlaceHolder, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import {
  deviceOfNumber,
  listOfAllocation,
  resourcesAllocation,
  resourcesHistory,
  resourcesReturn,
} from "../../api/resourcesApi";
import TableContainer from "../../components/common/tableContainer";
import {
  countOfData,
  findDevicesNumber,
} from "../../api/commonApi";
import { listOfEmployee } from "../../api/employeeApi";
import { getId } from "../../utils/helpers/custom";
import { ListOfDevice } from "../../utils/helpers/enums";
import Loader from "../../components/common/loader";
import { checkStatusCodeSuccess, CommonLabel, dateFormat, HandleResponse, TableSortFunction } from "../../utils/helpers/common";
import NoResultsMessage from "../../components/noResultMessage";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { ResourceLabel, Resources, ResourceStatus } from "../../common/constant/Resource";
import BaseButton from "../../components/BaseComponents/BaseButton";
import { Link } from "react-router-dom";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import BaseInput from "../../components/BaseComponents/BaseInput";
import BaseModal from "../../components/BaseComponents/BaseModal";

const AllocationDevice = () => {
  document.title = ResourceLabel.Allocation;
  const [resourceName, setResourceName] = useState("");
  const [isResource, setIsResource] = useState(true);
  const [device, setDevice] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalTodo, setModalTodo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [todo, setTodo] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [allocationList, setAllocationList] = useState([]);
  const [damageResourcesCardData, setDamageResourcesCardData] = useState("");
  const [historyData, setHistoryData] = useState();
  const [modelName, setModelName] = useState();
  const [returnModel, setReturnModel] = useState(false);
  const [submitDeviceDetails, setSubmitDeviceDetails] = useState();
  const [selectedDevice, setSelectedDevice] = useState();
  const [selectedDeviceName, setSelectedDeviceName] = useState();
  const [selectedModelDevice, setSelectedModelDevice] = useState("");
  const [selectedResourceId, setSelectedResourceId] = useState(null);
  const [modalLoader, setModalLoader] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  
  const eComWidgets = [
    {
      id: 1,
      cardColor: "primary",
      label: ResourceLabel.AllocateResource,
      badgeClass: "success",
      counter: damageResourcesCardData,
      bgcolor: "success",
      icon: "bx bx-user-plus",
      decimals: 0,
      prefix: "",
      suffix: "",
    },
  ];

  const fetchData = () => {
    setLoading(true);
    listOfAllocation()
      .then((resp) => {
        setAllocationList(resp?.data?.data);
      })
      .catch((err) => err);
    listOfEmployee({
      isDeleted: false,
    })
      .then((resp) => {
        setEmployeeList(resp?.data?.data?.map((item) => ({
        value: item.id,
        label: `${item.firstName} ${item.lastName}`,
      })))
      })
      .catch((err) => err)
      .finally(() => {});
    countOfData({
      modelName: "resourcesDetailsModel",
      condition: {
        status: ResourceLabel.Allocation,
      },
    })
      .then((res) => {
        setDamageResourcesCardData(res?.data?.data);
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleDeleteTodo = () => {
    if (todo) {
      setDeleteModal(false);
    }
  };

  const AddAllocation = () => {
    setTodo("");
    setModalTodo(!modalTodo);
    toggle();
  };

  const toggle = useCallback(() => {
    if (modalTodo) {
      setResourceName("");
      setSelectedModelDevice("");
      setIsResource(true);
      setReturnModel(false);
      validation.resetForm();
      setModalTodo(false);
      setTodo(null);
    } else {
      setModalTodo(true);
    }
  }, [modalTodo]);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      assignTo: todo?.assignTo || "",
      resourceNo: todo?.resourceId || "",
      resourceName: todo?.resourceNo || "",
      reason: todo?.reason || "",
    },
    validationSchema: Yup.object({
      assignTo:
      !returnModel && Yup.string().required(validationMessages.required(ResourceLabel.EmployeeName)),
      resourceNo: Yup.string().when("resourceName", {
        is: (resourceName) => [Resources.Laptop, Resources.Mouse].includes(resourceName),
        then: Yup.string().required(validationMessages.required(ResourceLabel.ResourceNo)),
        otherwise: Yup.string().notRequired(),
      }),
      resourceName: Yup.string().required(validationMessages.required(ResourceLabel.ResourceName)),
      reason: Yup.string().required(validationMessages.required(ResourceLabel.Reason)),
    }),
    onSubmit: (values) => {
      setModalLoader(true);
      if (!returnModel) {
        const allocationPayload = {
          resourceDetailsId: selectedResourceId,
          assignTo: parseInt(values.assignTo, 10),
          addedBy: parseInt(getId(), 10),
          remark: values.reason,
          status: ResourceLabel.Allocation,
        };
        resourcesAllocation(allocationPayload)
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              toast.success(res?.data?.message);
              fetchData();
              validation.resetForm();
              setResourceName("");
              toggle();
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => toast.error(err))
          .finally(() => {
            setModalLoader(false);
          });
      } else {
        const returnPayload = {
          resourceAssignId: submitDeviceDetails?.id,
          resourceDetailsId: submitDeviceDetails?.resourcesDetails?.id,
          remark: values.reason,
          status: ResourceStatus.Return,
        };
        resourcesReturn(returnPayload)
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              toast.success(res?.data?.message);
              fetchData();
              validation.resetForm();
              setResourceName("");
              toggle();
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => toast.error(err))
          .finally(() => {
            setModalLoader(false);
          });
      }
    },
  });

  const leaveFilterValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      resourceName: "",
      resourceNo: "",
    },
    onSubmit: (values) => {
      setTableLoader(true);
      const payload = {
        resourceName: values.resourceName,
        ...(values.resourceNo !=="" && { resourceNo: device?.find((item) => item?.value === values?.resourceNo).label }),
      }
      setTableLoader(true);
      resourcesHistory(payload)
        .then((response) => {
          setHistoryData(response?.data?.data);
          setSelectedDevice("");
          setSelectedDeviceName("");
        })
        .catch((err) => {
          return err;
        })
        .finally(() => {
          setTableLoader(false);
        });
    },
  });

  const historyColumns = useMemo(() => [
    {
      Header: ResourceLabel.ResourceName,
      accessor: "resourcesDetails.resourceName",
      filterable: false,
    },
    {
      Header: ResourceLabel.ResourceNo,
      accessor: "resourcesDetails.resourceNo",
      filterable: false,
    },
    {
      Header: ResourceLabel.EmployeeName,
      accessor: "firstName",
      filterable: false,
      Cell: (cell) => {
        return `${cell?.row?.original?.authUser?.firstName} ${cell?.row?.original?.authUser?.lastName}`;
      },
      sortType: (rowA, rowB) =>
        TableSortFunction(rowA, rowB, (row) =>
          `${row?.original?.authUser?.firstName} ${row?.original?.authUser?.lastName}`.toLowerCase()
        ),
    },
    {
      Header: ResourceLabel.AllocatedDate,
      accessor: "resourceAllocationDate",
      filterable: false,
      Cell: (cell) => {
        const date = cell?.row?.original?.resourceAllocationDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate
              ? dateFormat(date)
              : HandleResponse.NoData}
          </div>
        );
      },
    },
    {
      Header: ResourceLabel.SubmittedDate,
      accessor: "returnDate",
      filterable: false,
      Cell: (cell) => {
        const date = cell?.row?.original?.returnDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate
              ? dateFormat(date)
              : HandleResponse.NoData}
          </div>
        );
      },
    },
  ]);

  const allocationColumns = useMemo(() => [
    {
      Header: ResourceLabel.EmployeeName,
      accessor: "name",
      filterable: false,
      Cell: (cell) => {
        return `${cell?.row?.original?.authUser?.firstName} ${cell?.row?.original?.authUser?.lastName}`;
      },
    },
    {
      Header: ResourceLabel.ResourceName,
      accessor: "resourceName",
      filterable: false,
      Cell: (cell) => {
        return cell?.row?.original?.resourcesDetails?.resourceName;
      },
    },
    {
      Header: ResourceLabel.ResourceNo,
      accessor: "resourceNo",
      filterable: false,
      Cell: (cell) => {
        return cell?.row?.original?.resourcesDetails?.resourceNo;
      },
    },
    {
      Header: ResourceLabel.AllocatedDate,
      accessor: "createdAt",
      Cell: (cell) => {
        const date = cell?.row?.original?.resourceAllocationDate;
        return (
          <div>
            {dateFormat(date) !== CommonLabel.InvalidDate ? dateFormat(date) : HandleResponse.NoData}
          </div>
        );
      },
    },
    {
      Header: ResourceLabel.SubmitDevice,
      Cell: (cell) => {
        return (
          <div>
            <Link
              id={`Submit-${cell?.row?.original?.id}`}
              className="techround btn btn-sm btn-soft-info remove-list"
              onClick={() => {
                toggle();
                setModelName(ResourceLabel.SubmitDevice);
                setReturnModel(true);
                setSubmitDeviceDetails(cell?.row?.original);
              }}
              disabled={false}>
              <i className="ri-macbook-line"></i>
            </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={ResourceLabel.SubmitDevice}
                anchorId={`Submit-${cell?.row?.original?.id}`}
              />
          </div>
        );
      },
    },
  ]);

    let condition = !returnModel ?  { status: [ResourceStatus.Available, ResourceStatus.Return, ResourceStatus.Success] } : {status : [ResourceStatus.Allocation]};

  const fetchDeviceNumber = (value) => {
    deviceOfNumber({
      resourceName: value,
      ...condition
    }).then((res) => {
      setDevice(res?.data?.data?.map((status) => ({
        value: status?.id,
        label: status?.resourceNo,
      })));
    });
  }
  const fetchReturnDeviceNumber = (value) => {
    findDevicesNumber({
      resourceName: value,
    }).then((res) => {
      setDevice(res?.data?.data?.map((status) => ({
        value: status?.id,
        label: status?.resourceNo,
      })));
    });
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
          <Container fluid>
            <BreadCrumb title={ResourceLabel.AllocateResource} pageTitle="HRMS" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">{ResourceLabel.AllocateResource}</h5>
              </div>

              <div className="col-auto order-2 order-sm-3 ms-auto">
                <div className="hstack gap-2">
                  <BaseButton
                    color="primary"
                    type="button"
                    onClick={() => {
                      AddAllocation();
                      setModelName(ResourceLabel.AddAllocation);
                      setReturnModel(false);
                    }}>
                    <i className="ri-add-line mt-2" />
                    {ResourceLabel.Allocation}
                  </BaseButton>
                </div>
              </div>
            </Row>
            <Row>
              <Widgets data={eComWidgets} />
            </Row>
            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">{ResourceLabel.Allocation}</h5>
              </CardHeader>
              <CardBody>
                {(allocationList?.length > 0 || loading) ? (
                  <TableContainer
                    columns={allocationColumns}
                    data={allocationList || []}
                    isAddUserList={false}
                    customPageSize={5}
                    tableLoader={loading}
                    divClass="table-responsive table-card mb-1"
                    tableClass="align-middle table-nowrap"
                    theadClass="table-light text-muted"
                  />
                ) : (
                  <NoResultsMessage />
                )}
              </CardBody>
            </Card>

            <Card>
              <CardHeader>
                <h5 className="card-title mb-0">{ResourceLabel.ResourcesHistory}</h5>
              </CardHeader>
              <CardBody className="mt-4">
                <div className="p-3 bg-light rounded mb-4">
                  <Form onSubmit={leaveFilterValidation.handleSubmit}>
                    <Row className="g-2">
                      <Col lg={4}>
                        <div className="mb-3">
                          <BaseSelect
                            name="resourceName"
                            label={ResourceLabel.ResourceName}
                            placeholder={SelectPlaceHolder(ResourceLabel.ResourceName)}
                            options={ListOfDevice}
                            value={leaveFilterValidation.values.resourceName || selectedDeviceName}
                            handleChange={(field, value) => {
                              setSelectedDeviceName(value);
                              leaveFilterValidation.setFieldValue(field, value);
                              fetchReturnDeviceNumber(value);
                            }}
                            handleBlur={leaveFilterValidation.handleBlur}
                            touched={leaveFilterValidation.touched?.resourceName}
                            error={leaveFilterValidation.errors?.resourceName}
                          />
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div className="mb-3">
                          <BaseSelect
                            name="resourceNo"
                            label={ResourceLabel.ResourceNo}
                            placeholder={SelectPlaceHolder(ResourceLabel.ResourceNo)}
                            options={device}
                            value={leaveFilterValidation.values.resourceNo || selectedDevice}
                            handleChange={(field, value) => {
                              setSelectedDevice(value);
                              leaveFilterValidation.setFieldValue(field, value);
                            }}
                            handleBlur={leaveFilterValidation.handleBlur}
                            touched={leaveFilterValidation.touched?.resourceNo}
                            error={leaveFilterValidation.errors?.resourceNo}
                          />
                        </div>
                      </Col>
                      <Col lg={2}>
                        <div className="mb-3 p-4 ml-3 d-flex gap-2">
                          <BaseButton
                            color="primary"
                            type="submit"
                          >
                            {CommonLabel.Search}
                          </BaseButton>
                          <BaseButton
                            color="soft-success"
                            type="button"
                            onClick={() => {
                              leaveFilterValidation.resetForm();
                            }}
                            >
                              {CommonLabel.Clear}
                            </BaseButton>
                        </div>
                      </Col>
                      {(historyData?.length > 0 || tableLoader) ? (
                        <TableContainer
                          columns={historyColumns}
                          data={historyData || []}
                          isAddUserList={false}
                          customPageSize={5}
                          tableLoader={tableLoader}
                          divClass="table-responsive table-card mb-1"
                          tableClass="align-middle table-nowrap"
                          theadClass="table-light text-muted"
                        />
                      ) : (
                        <NoResultsMessage />
                      )}
                    </Row>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </Container>
      </div>
      <BaseModal
        open={modalTodo}
        onClose={() => {
          setResourceName("");
          setModalTodo(false);
          validation.resetForm();
        }}
        toggle={toggle}
        className="zoomIn"
        title={modelName}
        bodyClassName="p-4"
        submit={()=> validation.handleSubmit()}
        submitLabel={CommonLabel.Submit}
        submitLabelColor="primary"
        loader={modalLoader}
        closeLabel={CommonLabel.Cancel}
        closeLabelColor="ghost-success"
      >
        <div id="task-error-msg" className="alert alert-danger py-2"></div>
        <Form
          id="creattask-form"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          {!returnModel && (
            <div className="mb-3">
              <BaseSelect
                name="assignTo"
                label={ResourceLabel.EmployeeName}
                placeholder={SelectPlaceHolder(ResourceLabel.EmployeeName)}
                options={employeeList}
                value={validation.values.assignTo}
                handleChange={(field, value) => {
                  validation.setFieldValue(field, value);
                }}
                handleBlur={validation.handleBlur}
                touched={validation.touched?.assignTo}
                error={validation.errors?.assignTo}
                required
              />
            </div>
          )}

          <div className="mb-3">
            <BaseSelect
              name="resourceName"
              label={ResourceLabel.ResourceName}
              placeholder={SelectPlaceHolder(ResourceLabel.ResourceName)}
              options={ListOfDevice}
              value={validation.values.resourceName}
              required={true}
              handleChange={(field, value) => {
                setResourceName(value);
                setIsResource(false);
                fetchDeviceNumber(value);
                validation.setFieldValue(field, value);
              }}
              handleBlur={validation.handleBlur}
              touched={validation.touched?.resourceName}
              error={validation.errors?.resourceName}
            />
          </div>

          <div className="mb-3">
            <BaseSelect
              name="resourceNo"
              label={ResourceLabel.ResourceNo}
              placeholder={SelectPlaceHolder(ResourceLabel.ResourceNo)}
              options={device}
              value={validation.values.resourceNo}
              required={true}
              handleChange={(field, value) => {
                validation.setFieldValue(field, value);
                setSelectedModelDevice(value);
                setSelectedResourceId(value);
              }}
              handleBlur={validation.handleBlur}
              touched={validation.touched?.resourceNo}
              error={validation.errors?.resourceNo}
              isDisabled={isResource}
            />
          </div>

          <div className="mb-3">
            <BaseInput
              name="reason"
              type="text"
              label={ResourceLabel.Reason}
              placeholder={InputPlaceHolder(ResourceLabel.Reason)}
              onChange={validation.handleChange}
              handleBlur={validation.handleBlur}
              value={validation.values.reason}
              touched={validation.touched.reason}
              error={validation.errors.reason}
              required
            />
          </div>
        </Form>
      </BaseModal>

    </React.Fragment>
  );
};

export default AllocationDevice;
